import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface ErrorFilledSmallProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const ErrorFilledSmall = forwardRef<SVGSVGElement, ErrorFilledSmallProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.critical20}
          fillRule='evenodd'
          d='M12 22.504c5.8 0 10.5-4.7 10.5-10.5 0-5.799-4.7-10.5-10.5-10.5-5.799 0-10.5 4.701-10.5 10.5 0 5.8 4.701 10.5 10.5 10.5'
          clipRule='evenodd'
        ></path>
        <path
          fill={secondaryColor ?? '#912B2D'}
          fillRule='evenodd'
          d='M7.66 14.224a1.5 1.5 0 0 0 2.121 2.122l2.22-2.22 2.219 2.22a1.5 1.5 0 1 0 2.121-2.121l-2.22-2.22 2.222-2.222a1.5 1.5 0 0 0-2.121-2.121l-2.221 2.222-2.222-2.222a1.5 1.5 0 1 0-2.12 2.122l2.22 2.221-2.219 2.22'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

ErrorFilledSmall.displayName = 'ErrorFilledSmall';

export default ErrorFilledSmall;
